import { useState, useMemo, useEffect } from 'react'
import { createPortal } from 'react-dom'
import closeIcon from '../../../../../_metronic/images/closeSymbol.svg'
import * as Yup from 'yup'
import { Col, Modal } from 'react-bootstrap'
import EmailReport from './EmailReport'
import { useFormik } from 'formik'
import { useLazyQuery, useMutation } from '@apollo/client'
import { SEND_REPORTS_TO_EMAIL, CREATE_REPORT_SETTINGS } from '../../../../../utils/GraphQLAPI'
import { getToken, capitalizeFirstLetter, alert } from '../../../../../utils/helper'
import ScheduleRecurring from './ScheduleRecurring'
import fileDownload from 'js-file-download'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import { useParams } from 'react-router-dom'

type Props = {
  show: boolean
  handleClose: () => void
  filterOptions: any
  dateFilterType: string
  dynamicReportField?: any
  ECIReport?: any
  showPhoneNumber?: any
}

interface ReportFilters {
  reportTimeZone: string;
  reportType?: string;
  fromDate?: any;
  toDate?: any;
  customHeaders?: any[];
  tpvReportFields?: any[];
  commodityIds?: any;
  contractTypeIds?: any;
  customerTypeIds?: any;
  utilityIds?: any;
  tpvStatus?: any;
  qcStatus?: any;
  emailIds?: string[];
}


const modalsRoot = document.getElementById('root-modals') || document.body

const getValidationSchema = (currentScreen: string) => {
  switch (currentScreen) {
    case 'EMAILREPORT':
      return Yup.object({
        emailId: Yup.string().required('Email is required'),
        subject: Yup.string().required('Subject is required'),
        reportName: Yup.string().notRequired(), // Optional in this screen
      })
    case 'SCHEDULERECURRING':
      return Yup.object({
        emailId: Yup.string().notRequired(), // Optional in this screen
        subject: Yup.string().notRequired(), // Optional in this screen
        reportName: Yup.string().required('Report name is required'),
      })
    default:
      return Yup.object({
        emailId: Yup.string().notRequired(),
        subject: Yup.string().notRequired(),
        reportName: Yup.string().notRequired(),
      })
  }
}

const generateReportFileName = (reportType: string) => {
  const today = new Date()
  const dateString = moment(today).format('MM-DD-YYYY')
  return `Reports _ ${reportType.replace(' ', '')} _ ${dateString}`
}

const defaultConfig = {
  selectedTime: '12:00 AM',
  currentScreen: 'QUICKDOWNLOAD',
  scheduleType: 'DAILY',
  selectedDay: 'MONDAY',
  selectedDate: '1',
  fileFormat: 'EXCEL',
  isCheckAll: false,
}

const customerInfo = (adminUser: any, dynamicReportField: any, showPhoneNumber: boolean) => {
  const tempArr: string[] =
    adminUser === 'salesadmin'
      ? [
        'Customer First Name',
        'Customer Last Name',
        'Agent Name',
        'TPV Status',
        'Confirmation Number',
        'Unique ID',
        'Disposition',
        ...(showPhoneNumber ? ['Primary Phone'] : []),
        'QC Status'
      ]
      : [
        'Customer First Name',
        'Customer Last Name',
        'Business Name',
        'Sales Channel',
        'Agent Name',
        'Agent Leader Code',
        'TPV Type',
        'QC User Name',
        'Service Address 1',
        'Service Address 2',
        'Service City',
        'Service State',
        'Service Zip',
        'Service Unit Number',
        'Billing Address 1',
        'Billing Address 2',
        'Billing City',
        'Billing State',
        'Billing Zip',
        'Billing Unit Number',
        'Marketer Account Number',
        'Marketer DUNS Number',
        'Utility DUNS Number',
        'Primary Phone',
        'Account Number',
        'Product Name',
        'Customer Type',
        'Contract Type',
        'Commodity',
        'Utility',
        'TPV Date',
        'TPV Duration',
        'TPV Status',
        'QC Status',
        'EDI Status',
        'EDI Last Updated Date',
        'EDI Rejected Reason',
        'Disposition', // Fix typo here if 'Dispostiion' was unintentional
        'Account Type',
        'Billing Method',
        'Document Delivery',
        'Enrollment Submit Date',
        'Customer Email Address',
        'Rate',
        'Product Code',
        'Second Rate',
        'Service Fee',
        'Termination Fee',
        'Adder',
        'Term',
        'Confirmation Number',
        'Lead Created Date',
        'Brand Name',
        'Note1',
        'Note2',
        'Note3',
        'System Name',
        // 'Product Type',
        'EDI Recording Status',
        'Unique Id',
        'Language',
        'Agent Rep ID',
        'Rep ID'
      ];

  if (dynamicReportField?.enableContractStartDate && adminUser !== 'salesadmin') {
    tempArr.push('Contract Start Date');
  }

  if (dynamicReportField?.isUtilityMeterNumberRequired && adminUser !== 'salesadmin') {
    tempArr.push('Meter Number');
  }
  if (dynamicReportField?.enableLineTypeIntelligence && adminUser !== 'salesadmin') {
    tempArr.push('Phone Type');
  }
  const finalArr = tempArr.map((item) => ({
    columnName: item,
    checked: false,
  }));


  return finalArr;
};
const GetReportModaal = ({
  show,
  handleClose,
  filterOptions,
  dateFilterType,
  dynamicReportField,
  ECIReport,
  showPhoneNumber
}: Props) => {
  const [isCheckAll, setIsCheckAll] = useState<any>(false)
  const [fileFormat, setFileFormat] = useState<any>(defaultConfig.fileFormat)
  const getUrlParams = useParams()

  const tempArr: any = customerInfo(getUrlParams.adminUser, dynamicReportField, showPhoneNumber)
  const [columnConfig, setColumnConfig] = useState<any>([])
  const [currentScreen, setCurrentScreen] = useState(defaultConfig.currentScreen)
  const [scheduleType, setScheduleType] = useState(defaultConfig.scheduleType)
  const [selectedDay, setSelectedDay] = useState(defaultConfig.selectedDay)
  const [selectedDate, setSelectedDate] = useState('1')
  const [selectedTime, setSelectedTime] = useState<any>(defaultConfig.selectedTime)

  useEffect(() => {
    setColumnConfig(tempArr);
  }, [getUrlParams.adminUser, dynamicReportField, showPhoneNumber]);

  useMemo(() => {
    if (columnConfig?.filter((column: any) => !column.checked).length === 0 && !isCheckAll) {
      setIsCheckAll(!isCheckAll)
    }
  }, [columnConfig])
  const handleClick = (currentColumnName: any) => {
    const currentIndex = columnConfig.findIndex(
      (column: any) => column.columnName === currentColumnName
    )
    if (isCheckAll && columnConfig[currentIndex].checked) {
      setIsCheckAll(!isCheckAll)
    }
    setColumnConfig((prev: any) => {
      prev[currentIndex] = { ...prev[currentIndex], checked: !prev[currentIndex].checked }
      return [...prev]
    })
  }
  // Checkbox
  const handleSelectAll = () => {
    setColumnConfig((prev: any) => {
      return prev.map((column: any) => {
        return { ...column, checked: !isCheckAll }
      })
    })
    setIsCheckAll(!isCheckAll)
  }
  const [sendEmailReport] = useLazyQuery(SEND_REPORTS_TO_EMAIL, {
    onCompleted: (data) => {
      alert('Email sent successfully', 'success')
    },
    onError: (data) => {
      alert(data.message, 'error')
    },
  })
  const handleBackScreen = () => {
    setCurrentScreen('QUICKDOWNLOAD')
  }
  const handleModalClose = () => {
    handleClose()
  }
  const reportFilters: ReportFilters = {
    reportTimeZone: momentTimezone.tz.guess(),
    reportType: dateFilterType?.toUpperCase()?.replaceAll(' ', '_'),
    fromDate: filterOptions?.fromDate,
    toDate: filterOptions?.toDate,
    customHeaders: columnConfig
      .filter((column: any) => column.checked === true)
      .map((column: any) => column?.columnName?.toUpperCase()?.replaceAll(' ', '_')),
    tpvReportFields: columnConfig
      .filter((column: any) => column.checked === true)
      .map((column: any) => column?.columnName?.toUpperCase()?.replaceAll(' ', '_')),
    commodityIds: filterOptions?.commodityId
      ? [filterOptions?.commodityId]
      : filterOptions?.commodityId,
    contractTypeIds: filterOptions?.contractTypeId
      ? [filterOptions?.contractTypeId]
      : filterOptions?.contractTypeId,
    customerTypeIds: filterOptions?.customerTypeId
      ? [filterOptions?.customerTypeId]
      : filterOptions?.customerTypeId,
    utilityIds: filterOptions?.utilityId ? [filterOptions?.utilityId] : filterOptions?.utilityId,
    tpvStatus: filterOptions?.tpvStatus ? [filterOptions?.tpvStatus] : filterOptions?.tpvStatus,
    qcStatus: filterOptions?.qcStatus ? [filterOptions?.qcStatus] : filterOptions?.qcStatus,
  }
  const formik = useFormik({
    initialValues: {
      emailId: '',
      subject: '',
      reportName: '',
    },
    validationSchema: getValidationSchema(currentScreen),
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      if (currentScreen === 'EMAILREPORT') {
        const emailIds = values.emailId.split(',')
        const regex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const regexResult = emailIds.map((emailId) => regex.test(emailId.trim()))

        if (regexResult.some((result) => result === false)) {
          alert('Invalid Email Ids', 'error')
        } else {
          await sendEmailReport({
            variables: {
              emailIds,
              subject: values.subject,
              reportFilters,
              reportFormat: fileFormat,
            },
          })
          handleModalClose()
        }
      } else if (currentScreen === 'SCHEDULERECURRING') {
        handleScheduleApi()
      }

      setSubmitting(false)
    },
  })
  useMemo(() => {
    if (show) {
      setCurrentScreen(defaultConfig.currentScreen)
      setSelectedDay(defaultConfig.selectedDay)
      setFileFormat(defaultConfig.fileFormat)
      setColumnConfig((prev: any) =>
        prev.map((columnConfig: any) => {
          return { ...columnConfig, checked: false }
        })
      )
      isCheckAll && setIsCheckAll(false)
      formik.setValues({ emailId: '', subject: '', reportName: '' })
      formik.setTouched({})
      setSelectedTime(defaultConfig.selectedTime)
    }
  }, [show])

  useEffect(() => {
    formik.setValues({
      emailId: '',
      subject: '',
      reportName: '',
    })
    formik.setTouched({})
    formik.setErrors({})
  }, [currentScreen])
  const capitalizeFirstLetterQC = (string: string) => {
    if (string === 'AUTO_APPROVED') {
      return ['Auto_Approved']
    }
    else {
      return [capitalizeFirstLetter(string)]
    }
  }
  const handleRestAPIDownload = async (downloadURL: string, mode: string) => {
    const TOKEN = await getToken()
    let body = {
      commodityIds: filterOptions?.commodityId
        ? [filterOptions?.commodityId]
        : filterOptions?.commodityId,
      contractTypeIds: filterOptions?.contractTypeId
        ? [filterOptions?.contractTypeId]
        : filterOptions?.contractTypeId,
      customerTypeIds: filterOptions?.customerTypeId
        ? [filterOptions?.customerTypeId]
        : filterOptions?.customerTypeId,
      utilityIds: filterOptions?.utilityId ? [filterOptions?.utilityId] : filterOptions?.utilityId,
      tpvStatus: filterOptions?.tpvStatus
        ? [capitalizeFirstLetter(filterOptions?.tpvStatus)]
        : filterOptions?.tpvStatus,
      qcStatus: filterOptions?.qcStatus
        ? capitalizeFirstLetterQC(filterOptions?.qcStatus)
        : filterOptions?.qcStatus,
      reportType: dateFilterType,
      fromDate: filterOptions?.fromDate,
      toDate: filterOptions?.toDate,
      reportTimeZone: momentTimezone.tz.guess(),
      customHeaders: columnConfig
        .filter((column: any) => column.checked === true)
        .map((column: any) => column?.columnName?.toUpperCase()),
      tpvReportFields: columnConfig
        .filter((column: any) => column.checked === true)
        .map((column: any) => column?.columnName?.toUpperCase()),
    }
    if (mode === 'ECI') {
      body = {
        ...body,
        commodityIds: null,
        contractTypeIds: null,
        customerTypeIds: null,
        utilityIds: null,
        tpvStatus: ["Passed"],
        qcStatus: ["Accepted", "Auto_Approved"],
      }
    } else if (mode === 'CustomECI') {
      body = {
        ...body,
        commodityIds: null,
        contractTypeIds: null,
        customerTypeIds: null,
        utilityIds: null,
        tpvStatus: null,
        qcStatus: null,
      }
    }
    const res = await fetch(downloadURL, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${TOKEN}`,
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(body),
    })
    handleModalClose()
    const blob = await res.blob()

    const newBlob = new Blob([blob])

    if (mode === 'QUICK_DOWNLOAD') {
      fileDownload(
        newBlob,
        `${generateReportFileName(dateFilterType)}${fileFormat === 'EXCEL' ? '.xlsx' : '.csv'}`
      )
    } else if (mode === 'ECI' || mode === 'CustomECI') {
      fileDownload(newBlob, `${generateReportFileName(dateFilterType)}.csv`)
    }
  }
  const [scheduleReport] = useMutation(CREATE_REPORT_SETTINGS, {
    onCompleted: () => {
      alert('Scheduled report successfully', 'success')
      handleModalClose()
    },
    onError: (err) => {
      alert(err.message, 'error')
    },
  })
  const handleScheduleApi = () => {
    const emailInput = formik.values.emailId?.trim();
    if (emailInput) {
      const emailIds = emailInput.split(',').map((email) => email.trim());
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const invalidEmails = emailIds.filter((emailId) => !regex.test(emailId));
      if (invalidEmails.length > 0) {
        alert('Invalid Email Ids', 'error')
        return;
      }
      reportFilters['emailIds'] = emailIds;
    } else {
      reportFilters['emailIds'] = [];
    }

    scheduleReport({
      variables: {
        createReportSettingsInput: {
          reportTime: selectedTime,
          reportDay: scheduleType === 'WEEKLY' ? selectedDay : null,
          calendarDay: scheduleType === 'MONTHLY' ? parseInt(selectedDate) : null,
          reportFrequency: scheduleType,
          reportTimeZone: 'ET',

          reportType: dateFilterType?.toUpperCase()?.replaceAll(' ', '_'),
          reportFilters,
          reportFormat: fileFormat,
          reportName: formik.values.reportName,
          reportFor: 'TPV',
        },
      },
    })
    handleModalClose()
  }


  const renderOptions = (value: any, i: number) => {
    let fieldName = value.columnName;
    if (value.columnName === 'Dispostiion') {
      fieldName = 'Disposition';
    } else if (value.columnName === 'Meter Number') {
      fieldName = 'Meter ID';
    }
    return (
      <Col lg={4} md={4} sm={4} className='mt-2' key={i}>
        <label className='form-check align-items-start form-check-sm form-check-custom form-check-solid me-5 mt-2'>
          <input
            className='form-check-input bg-light-primary ms-3'
            type='checkbox'
            key={value.columnName}
            name='saleschannel'
            checked={value.checked}
            onClick={(e) => handleClick(value.columnName)}
          />
          <span className='ms-4 text-gray-700 fw-semibold'>
            {fieldName}
          </span>
        </label>
      </Col>
    )
  }
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px'
      show={show}
      onHide={handleModalClose}
      backdrop={true}
    >
      <div className='modal-header'>
        <h4 className='modal-title'>Get Report</h4>
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={() => handleModalClose()}
        >
          <img className='svg-icon-1' src={closeIcon} alt='close' />
        </div>
      </div>

      <div className='modal-body'>
        <div className='modal-md'>
          <div className='modal-content'>
            <div className='modal-body pt-0'>
              {currentScreen === 'EMAILREPORT' && <EmailReport formik={formik} />}
              {currentScreen === 'QUICKDOWNLOAD' && (
                <div>
                  <h4 className='fs-3 text-gray-800 fw-bolder'>Customize Reports</h4>
                  <p className='text-gray-500 fs-7 fw-semibold'>
                    All reports will be in Eastern Time (ET)
                  </p>
                  <div
                    className={`row mt-5  overflow-scroll ${getUrlParams.adminUser === 'salesadmin' ? 'h-200px' : 'h-300px'
                      }`}
                  >
                    <Col lg={12} md={12} sm={12} className='mt-2'>
                      <label className='form-check form-check-sm form-check-custom form-check-solid mb-3 d-inline-block'>
                        <input
                          className='form-check-input bg-light-primary'
                          type='checkbox'
                          name='selectAll'
                          id='selectAll'
                          onClick={() => handleSelectAll()}
                          checked={isCheckAll}
                        />{' '}
                        <span className='ms-4 text-gray-700 fw-semibold'>Select All Columns</span>
                      </label>
                    </Col>
                    {columnConfig.map(renderOptions)}

                  </div>
                  <div className='mt-4 mb-4'>
                    <h6>Download Format</h6>
                    <div className='form-check form-check-custom form-check-solid'>
                      <input
                        className='form-check-input'
                        type='radio'
                        checked={fileFormat === 'EXCEL'}
                        onClick={() => setFileFormat('EXCEL')}
                      />
                      <span className='ms-2'>Excel</span>
                      <input
                        className='form-check-input ms-4'
                        type='radio'
                        checked={fileFormat === 'CSV'}
                        onClick={() => setFileFormat('CSV')}
                      />
                      <span className='ms-2'>CSV</span>
                    </div>
                  </div>
                </div>
              )}
              {currentScreen === 'SCHEDULERECURRING' && (
                <ScheduleRecurring
                  scheduleType={scheduleType}
                  setScheduleType={setScheduleType}
                  selectedDay={selectedDay}
                  setSelectedDay={setSelectedDay}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  selectedTime={selectedTime}
                  setSelectedTime={setSelectedTime}
                  formik={formik}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className='modal-footer'>
        {currentScreen === 'QUICKDOWNLOAD' ? (
          <>
            {getUrlParams.adminUser !== 'salesadmin' && (
              <>
                <button
                  className='btn btn-light'
                  data-bs-dismiss='modal'
                  onClick={() =>
                    handleRestAPIDownload(
                      `${process.env.REACT_APP_BASE_URL}downloads/ediReports/${ECIReport ? 'SPARK_SYSTEM' : 'EC_INFO_SYSTEM'}`,
                      `${ECIReport ? 'CustomECI' : 'ECI'}`
                    )
                  }
                >
                  {ECIReport ? 'Canned Report' : 'ECI Report'}
                </button>

                {/* <button
                  type='button'
                  className='btn btn-light'
                  onClick={() => setCurrentScreen('EMAILREPORT')}
                  disabled={!columnConfig?.some((column: any) => column.checked)}
                >
                  Email report
                </button> */}
                <button
                  type='button'
                  className='btn btn-light'
                  disabled={!columnConfig?.some((column: any) => column.checked)}
                  onClick={() => setCurrentScreen('SCHEDULERECURRING')}
                >
                  Schedule download
                </button>
              </>
            )}
            <button
              className='btn btn-primary'
              data-bs-dismiss='modal'
              onClick={() =>
                handleRestAPIDownload(
                  `${process.env.REACT_APP_BASE_URL}downloads/tpvReports/${fileFormat === 'EXCEL' ? 'Excel' : 'Csv'
                  }`,
                  'QUICK_DOWNLOAD'
                )
              }
              disabled={!columnConfig?.some((column: any) => column.checked)}
            >
              Quick download
            </button>
          </>
        ) : (
          <>
            <button type='button' className='btn btn-light' onClick={() => handleBackScreen()}>
              Back
            </button>
            <button
              className='btn btn-primary'
              onClick={() => {
                formik.submitForm()
              }}
              data-bs-dismiss='modal'
            >
              Save
            </button>
          </>
        )}
      </div>
    </Modal>,
    modalsRoot
  )
}

export { GetReportModaal }

